import angular from 'angular';
import { aiAgentComponents } from './components';
import { aiAgentServicesModule } from './services';
import { agentStoreModule } from './store';
export const aiAgentModule = angular
    .module('aiAgentModule', [aiAgentComponents, aiAgentServicesModule, agentStoreModule])
    .name;
